// React import
import * as React from 'react';
// Standard layout imports
import { Columns, Column } from 'src/components/Layout/Grid';
import Box from 'src/components/Box';
import Wrapper from 'src/components/Wrapper';
import Title from 'src/components/Title';
import notePic from 'src/images/Courses/note.png';
import Line from 'src/components/Line';
import { Link, Redirect } from 'react-router-dom';
import MyPageInfo from '../MyPage/myPageInfo.component';
import { IActivityThemeModel } from 'src/Entities/ActivityTheme/ActivityTheme';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Action } from 'redux-actions';
import { ActivityThemeSelector } from 'src/Entities/ActivityTheme/ActivityTheme.Selector';
import Accordion from 'src/components/Accordion';
import AccordionItem from 'src/components/Accordion/AccordionItem';
import { ActivityCategorySelector } from 'src/Entities/ActivityCategory/ActivityCategory.Selector';
import ActivityCategory from 'src/Entities/ActivityCategory/ActivityCategory';
import CategoryActivitiesComponent from './categoryActivities.component';
import Breadcrumb from 'src/components/Breadcrumb';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem';
import SearchComponent from '../SeachPage/Seach.component';
import { UserSelector } from 'src/Entities/User/User.Selector';
import FlexContainer from 'src/components/Layout/FlexContainer';
import { setSlecetedActivtyAction } from 'src/Entities/PortalState/PortalState.Actions';

interface IActivitiesProps {
  theme: IActivityThemeModel;
  categories: ActivityCategory[];
  setSelectedActivity: (
    detailKursuId: string,
    themeId: string,
    categoryId: string
  ) => void;
}
interface IActivitiesState {
  themeId: number;
  shouldRedirectToCourse: boolean;
}

class Activities extends React.Component<IActivitiesProps, IActivitiesState> {
  /**
   *
   */
  constructor(props: any) {
    super(props);
    this.state = {
      themeId: props.match.params.themeid,
      shouldRedirectToCourse: false
    };
    this.onActivitySelect = this.onActivitySelect.bind(this);
  }

  public onActivitySelect(
    detailKursusId: string,
    themeId: string,
    categoryId: string
  ) {
    this.props.setSelectedActivity(detailKursusId, themeId, categoryId);
    this.setState({ shouldRedirectToCourse: true });
  }
  // init a state with the data from the theme.
  // handle direct access to this page.
  public render() {
    if (!this.props.theme) {
      location.replace('kursusportal/home');
      return null;
    } else {
      return (
        <div>
          <Wrapper>
            <FlexContainer justifyContent="between" className="pt3">
              <div>
                <Breadcrumb className="pt3">
                  <BreadcrumbItem>
                    <Link to="/Home">FORSIDE</Link>{' '}
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link to="/kurser/">KURSER</Link>{' '}
                  </BreadcrumbItem>
                  <BreadcrumbItem active={true}>
                    <Link
                      to={'kursusportal/Kurser/' + this.props.theme.themeId}
                    >
                      {this.props.theme.name}
                    </Link>
                  </BreadcrumbItem>
                </Breadcrumb>
              </div>
            </FlexContainer>
          </Wrapper>

          <Box className="mb4">
            <Wrapper>
              <div className="has-background-gray-body ">
                <Columns gutter="default">
                  <Column md={5}>
                    <div className="pa3">
                      <Title className="mb2" size="default">
                        {this.props.theme ? this.props.theme.name : ''}
                      </Title>
                      {this.props.theme.description}
                    </div>
                  </Column>
                  <Column md={7}>
                    {this.props.theme.themeImageUrl ? (
                      <div
                        style={{
                          height: '300px',
                          overflow: 'hidden',
                          backgroundSize: 'cover',
                          backgroundImage: `url(${this.props.theme.themeImageUrl})`
                        }}
                      />
                    ) : undefined}
                  </Column>
                </Columns>
              </div>
            </Wrapper>
          </Box>

          {/* SEARCHBAR */}
          <div className=" has-background-gray-body">
            <Wrapper className="mt-12">
              <div style={{ transform: 'translateY(-46px)' }}>
                <SearchComponent />
              </div>
              <Columns gutter="default">
                <Column md={8}>
                  <Title className="mb2">
                    ELLER GÅ PÅ OPDAGELSE I{' '}
                    {this.props.theme ? this.props.theme.name : ''} Kurser
                  </Title>

                  <Accordion>
                    {this.props.categories.map(c => (
                      <AccordionItem key={c.categoryId} title={c.name}>
                        <div className="pb3 pl5 pt2 pr2">
                          <CategoryActivitiesComponent
                            onSelectActivity={this.onActivitySelect}
                            categoryId={c.categoryId}
                            themeId={this.props.theme.themeId}
                          />
                        </div>
                      </AccordionItem>
                    ))}
                  </Accordion>

                  <Line />
                </Column>
                <Column md={4}>
                  <MyPageInfo />
                </Column>
              </Columns>
            </Wrapper>
          </div>
          {this.state.shouldRedirectToCourse ? (
            <Redirect to="/kursus/" push={true} />
          ) : null}
        </div>
      );
    }
  }
}
function mapStateToProps(state: any, ownProps: any) {
  const themeId = ownProps.match.params.themeid;
  return {
    theme: ActivityThemeSelector.getThemeById(themeId),
    categories: ActivityCategorySelector.getCategoriesByThemeId(
      themeId,
      UserSelector.isShowOnlyUserIntrests()
    )
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>, ownProps: any) {
  return {
    setSelectedActivity: (
      detailKursusid: string,
      themeId: string,
      categoryId: string
    ) => dispatch(setSlecetedActivtyAction(detailKursusid, themeId, categoryId))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Activities);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Activityies/index.tsx